import styled from 'styled-components'
import Header from '../components/Waiter/Header'
import Footer from '../components/Waiter/Footer'
import { useEffect, useState } from 'react'
import {
    OrderItemsContext,
    OrderDataContext,
    ErrorContext,
    LocationsContext,
    MenuContext,
    AvailableDatesContext,
    MenuGroupsContext,
    WaiterContext
} from "../components/Waiter/Context/WaiterContext"
import { format } from 'date-fns'
import Api from "../api/api";
import UrlError from "../components/UrlError";
import { ErrorBoundary } from 'react-error-boundary'
import { useParams } from 'react-router-dom'
import First from '../components/Waiter/Steps/First'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { StyledEngineProvider } from '@mui/material/styles';
import Second from '../components/Waiter/Steps/Second'
import Third from '../components/Waiter/Steps/Third'
import Fourth from '../components/Waiter/Steps/Fourth'
// import ActionPopup from '../components/Waiter/Components/ActionPopup'

function Waiter () {
    const routeParams = useParams();

    const [appLoading, setAppLoading] = useState(true)
    const [errors, setErrors] = useState({})
    const [orderItems, setOrderItems] = useState({})
    const [page, setPage] = useState('first')
    const [menu, setMenu] = useState([])
    const [menuGroups, setMenuGroups] = useState([])
    const [locations, setLocations] = useState([])
    const [urlError, setUrlError] = useState(false)
    const [today, setToday] = useState(format(new Date(), 'y-MM-dd'))
    const [action, setAction] = useState(null)
    const [workendAction, setWorkendAction] = useState(null)
    const [availableDates, setAvailableDates] = useState([]);
    const [order, setOrder] = useState({
        table: null,
        guests: null,
        location: 'restaurant',
        comment: null,
        price: 0,
        success: false,
        time: format(new Date(), 'HH:mm'),
        date: new Date(),
    })

    const [waiter, setWaiter] = useState({
        name: null,
    });

    // useEffect(() => {
    //     let intervalId;

    //     const fetchActions = async () => {
    //         return Api.getPendingAction(routeParams.waiter).then((response) => {
    //             if (response.actions) {
    //                 const instantActions = response.actions.filter(action => action.type === 'time');
    //                 if (instantActions.length > 0) {
    //                     setAction(instantActions[0])
    //                 }
    //                 const workendActions = response.actions.filter(action => action.type === 'work-end');
    //                 if (workendAction === null && workendActions.length > 0) {
    //                     setWorkendAction(workendActions[0])
    //                 }
    //             }
    //         })
    //     };

    //     if (!action) {
    //         intervalId = setInterval(() => {
    //             fetchActions();
    //         }, 3000);
    //     }

    //     return () => {
    //         if (intervalId) {
    //             clearInterval(intervalId);
    //         }
    //     };
    // }, [action]);

    useEffect(() => {
        const interval = setInterval(() => {
            const newDay = format(new Date(), 'y-MM-dd')
            if (today !== newDay) {
                setToday(newDay)
            }
        }, 60 * 1000)

        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        setAppLoading(true)
        Api.notify({
            text: 'Loading page...',
            data: {}
        });
        if (routeParams.waiter) {
            Api
                .getWaiterData(routeParams.waiter)
                .then(waiterData => {
                    if (waiterData.name) {
                        setWaiter({
                            name: waiterData.name,
                            slug: routeParams.waiter,
                        })
                        Api.getWaiterMenu().then((response) => {
                            setMenu(response.items)
                            setMenuGroups(response.groups)
                        });

                        Api.getWaiterLocations().then((response) => {
                            setLocations(response)
                        }).finally(() => {
                            setAppLoading(false)
                        })
                    } else {
                        window.location.href = 'https://reservations.bohemehouse.lt/'
                    }
                })
                .catch(() => {
                    window.location.href = 'https://reservations.bohemehouse.lt/'
                })
                .finally(() => {
                    setAppLoading(false)
                });

        }
    }, [today])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [page])

    useEffect(() => {
        recalculatePrice();
    }, [JSON.stringify(orderItems), menu.length])

    const recalculatePrice = () => {
        let totalPrice = 0

        for (const [id, data] of Object.entries(orderItems)) {
            const item = menu.find(element => element.id === Number(id))

            if (item) {
                totalPrice += item.price * data.quantity
            }
            if (data.children) {
                for (const [index, children] of Object.entries(data.children)) {
                    for (const [childId, childData] of Object.entries(children)) {
                        if (childData.quantity > 0) {
                            totalPrice += childData.price * childData.quantity
                        }
                    }
                }
            }
        }
        setOrder((prev) => ({ ...prev, price: totalPrice }))
    }

    const renderPage = () => {
        if (urlError) {
            return <UrlError />
        }

        switch (page) {
            case 'first':
                return <First page={page} />
            case 'second':
                return <Second page={page} />
            case 'third':
                return <Third page={page} />
            case 'fourth':
                return <Fourth page={page} setPage={setPage} />
        }
    }

    if (appLoading) {
        return <Loading><div>Loading...</div></Loading>
    }

    function ErrorFallback ({ error, resetErrorBoundary }) {
        return (
            <div role="alert">
                <p>Something went wrong:</p>
                <pre>{error.message}</pre>
                <button onClick={resetErrorBoundary}>Try again</button>
            </div>
        )
    }

    return (
        <Layout>

            <StyledEngineProvider injectFirst>
                <ErrorContext.Provider value={{ errors, setErrors }}>
                    <MenuGroupsContext.Provider value={{ menuGroups }}>
                        <LocationsContext.Provider value={{ locations, setLocations }}>
                            <MenuContext.Provider value={{ menu, setMenu }}>
                                <AvailableDatesContext.Provider value={{ availableDates, setAvailableDates }}>
                                    <OrderDataContext.Provider value={{ order, setOrder }}>
                                        <WaiterContext.Provider value={{ waiter, setWaiter }}>
                                            <OrderItemsContext.Provider value={{ orderItems, setOrderItems }}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <ErrorBoundary
                                                        FallbackComponent={ErrorFallback}
                                                        onReset={() => {
                                                            // reset the state of your app so the error doesn't happen again
                                                        }}
                                                    >
                                                        {/* {action && action.id && <ActionPopup action={action} setAction={setAction}></ActionPopup>} */}
                                                        <Header
                                                            page={page}
                                                            setPage={setPage}
                                                            workendAction={workendAction}
                                                            setWorkendAction={setWorkendAction}
                                                        />
                                                        <Content>
                                                            {renderPage()}
                                                        </Content>
                                                        {!urlError &&
                                                            <Footer page={page} setPage={setPage} />
                                                        }
                                                    </ErrorBoundary>
                                                </LocalizationProvider>
                                            </OrderItemsContext.Provider>
                                        </WaiterContext.Provider>
                                    </OrderDataContext.Provider>
                                </AvailableDatesContext.Provider>
                            </MenuContext.Provider>
                        </LocationsContext.Provider>
                    </MenuGroupsContext.Provider>
                </ErrorContext.Provider>
            </StyledEngineProvider>
        </Layout>
    )
}

const Loading = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 100vh;
    text-align: center;
`

const Layout = styled.div`
  display: flex;
  flex: 1;
  min-height: 100vh;
  width: 100%;
  padding: 100px 15px 150px 15px;
`

const Content = styled.div`
  display: flex;
  flex: 1;
  min-height: 100%;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;

  & > div {
    display: flex;
    width: 100%;
  }
`

export default Waiter
